export default "__VITE_ASSET__fxHQPKuG__"